import { render, staticRenderFns } from "./app-automation-details-loader.vue?vue&type=template&id=61636222"
import script from "./app-automation-details-loader.vue?vue&type=script&lang=js"
export * from "./app-automation-details-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports